import styled, { css } from "styled-components";
import Select from "react-select";
import AsyncSelect from "react-select/async";

const commonStyle = css`
  .react-select__option {
    &.react-select__option--is-focused {
      background: ${({ primary }) => primary} !important;
      color: #fff !important;
    }
    &:hover {
      background: ${({ primary }) => primary} !important;
      color: #fff !important;
    }
  }
  .react-select__value-container,
  .react-select__menu {
    &,
    * {
      color: ${({ color }) => color} !important;
      font-size: 15px;
    }
  }
  .react-select__control {
    background: ${({ backgroundColor }) => backgroundColor} !important;
    border-color: ${({ isInvalid, borderColor, red }) => (isInvalid ? red : borderColor)} !important;
  }
  .react-select__menu {
    background: ${({ backgroundColor }) => backgroundColor} !important;
    z-index: 10;
  }
  .react-select__multi-value {
    background: ${({ primary }) => primary} !important;
    color: #fff !important;
  }
  .react-select__multi-value__remove {
    background: rgba(0, 0, 0, 0.1) !important;
    &,
    * {
      color: #fff !important;
    }
  }
  .react-select__multi-value__label {
    font-weight: bold;
    font-size: 12px !important;
    color: #fff !important;
  }

  .react-select__multi-value--is-disabled {
    opacity: 0.4;
  }
`;

export const ReactAsyncSelect = styled(AsyncSelect)`
  ${commonStyle}
`;

export const ReactSelect = styled(Select)`
  ${commonStyle}
`;
